import { Col } from 'antd';
import { Row } from 'antd';
import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import { approveButton } from './constants/approve-button.constant';
import { cancelButton } from './constants/cancel-button.constant';
import { statusNames } from './constants/status-names.constant';
import { confirmButton } from './constants/confirm-button.constant';
import { CustomNotification } from '../../../../../v2-components/Notification';
import './style.scss';


export default function StatusCard(props) {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openCancel, setOpenCancel] = useState(false);


	const validateProducts = () => {
		// if (!props.products || props.products.length < 1) {
		// 	return false;
		// }
		const firstProduct = props?.products[0];
		const hasValidName = firstProduct?.name && firstProduct?.name?.trim() !== '';
		const hasValidPrice = firstProduct?.price && firstProduct?.price > 0;
		if (!hasValidName || !hasValidPrice) {
		CustomNotification({ type: 'error', message: 'Faltan datos', description: 'Recuerda cargar el detalle de los productos' });
		}
		return hasValidName && hasValidPrice
	};

	const handleCancel = () => {
		const isProductSelected = validateProducts()
		if (isProductSelected) {
			setOpenCancel(true);
		}
	};

	const handleReject = async () => {
		await props.handleCancelQuotation();
		setOpenCancel(false);
	};

	const handleApprove = async () => {
		await props.handleApproveQuotation();
		setOpenConfirm(false);
	};
	const handleNext = () => {
		const isProductSelected = validateProducts()
		if (isProductSelected) {
			setOpenConfirm(true);
		}
	};


	return (
		<Row>
			<Row>
				<Col span={24}>
					<h3>Estado de la solicitud</h3>
					<span>{statusNames[Enviroment.LANGUAGE][props?.statusNumber]}</span>
				</Col>
				{props?.statusNumber === 100 && (
					<>
						<p>Antes de cerrar la solicitud de producto verifica los datos.</p>
						<p>Tambien puedes rechazarla desde aquí</p>
					</>
				)}
				{(props?.statusNumber === 100 || props?.statusNumber === 400) && (
					<p>El usuario tendra 10 días para realizar la compra. Una vez pasado ese plazo se rechazará la cotización</p>
				)}
			</Row>
			<Row justify={'end'}>
				<Col>

					<CustomButton style={{ opacity: props?.statusNumber === 100 ? 1 : 0, backgroundColor: '#D2000C', color: '#FFFFFF', }} onClick={handleCancel} disabled={props?.statusNumber !== 100}>
						{cancelButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
				<Col>
					<CustomButton style={{ opacity: props?.statusNumber === 100 ? 1 : 0, backgroundColor: '#088926', color: '#FFFFFF', marginLeft: '30px' }} onClick={handleNext} disabled={props?.statusNumber !== 100}>
						{approveButton[Enviroment.LANGUAGE][props?.statusNumber]}
					</CustomButton>
				</Col>
			</Row>

			<CustomModal onCancel={() => setOpenConfirm(false)} footer={null} open={openConfirm}>
				{console.log('entro al modal de avanazar')}
				<h2>Avanzar</h2>
				<CustomDivider />
				<h5>Al darle a continuar estas confirmando que el estado está completo</h5>
				<p>Si estas de acuerdo dale a continuar</p>
				<CustomDivider />
				<div className="button-container">
					<CustomButton onClick={() => setOpenConfirm(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleApprove}>{confirmButton[Enviroment.LANGUAGE][props?.statusNumber]}</CustomButton>
				</div>
			</CustomModal>

			<CustomModal onCancel={() => setOpenCancel(false)} footer={null} open={openCancel}>
				<h2>Rechazar cotización</h2>
				<CustomDivider />
				<h4>¿Estás seguro de cancelar la cotización?</h4>
				<p>Se le enviará al usuario una notificación con el rechazo de la cotización.</p>
				<CustomDivider />
				<div>
					<CustomButton onClick={() => setOpenCancel(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleReject}>Rechazar cotización</CustomButton>
				</div>
			</CustomModal>
		</Row>
	);
}
